<template>
  <div class="c-app flex-row align-items-center">
    <CContainer class="col-md-7">
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <h1>Forgot password</h1>
                <p class="text-muted">Enter email assigned to your account</p>
                <CForm @submit.prevent="handleSubmit">
                  <CInput
                      placeholder="Email"
                      autocomplete="email"
                      v-model="email"
                      name="email"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-user"/>
                    </template>
                  </CInput>
                  <CRow class="mt-2">
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        type="submit"
                        data-cy="reset-password-btn"
                      >
                        Reset password
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <LoginRight/>
  </div>
</template>

<script>
import { AuthService } from '@/services/auth';
import LoginRight from '@/components/LoginRight';

export default {
  name: 'ForgotPassword',
  components: { LoginRight },
  data: function () {
    return {
      email: '',
    };
  },
  methods: {
    async handleSubmit() {
      await AuthService.forgotPassword(this.email);
      alert(this.$t('Password change requested. Please check your email.'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
      this.$router.push({ name: 'ManagementLogin' });
    },
  },
};
</script>
